import {
  AppBar,
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  SvgIcon,
  Toolbar,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import { Logout } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { WSIcons } from "../../commonFunctions/iIcons";
import { callAPI, getLocalValue, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../Snackbar/SnackBarContext";
import WSLoadingOverlay from "../WSLoadingOverlay";

interface NavbarProps {
  collapse: boolean;
  drawerWidth?: number;
  anchorEl: null | HTMLElement;
  badgeContent?: number;
  position?: "fixed" | "absolute" | "relative" | "static" | "sticky";
  backgroundColor?: string;
  iconColor?: string;
  height?: string;
}

const Navbar2: React.FC<NavbarProps> = ({ backgroundColor = "#ffffff", collapse }) => {
  let UserId = localStorage.getItem("UserId");

  const navigate = useNavigate();
  const { showMessage } = useSnackbar();

  const [loading,setLoading]=useState(false);
  const [profileAnchor, setProfileAnchor] = useState<null | HTMLElement>(null);
  const openProfileMenu = (event: React.MouseEvent<HTMLElement>) =>
    setProfileAnchor(event.currentTarget);
  const closeProfileMenu = () => setProfileAnchor(null);

  const [feedbackAnchor, setFeedbackAnchor] = useState<null | HTMLElement>(
    null
  );

  const openFeedbackMenu = (event: React.MouseEvent<HTMLElement>) => {
    setFeedbackAnchor(event.currentTarget);
  };

  const closeFeedbackMenu = () => {
    setFeedbackAnchor(null);
  };

  const handleLogout = async () => {
    try {
      setLoading(true)
      const response: any = await callAPI("/auth/logout", Method.POST, {
        userId: UserId
      });

      console.log("response is",response);
      if (response?.success) {
        localStorage.clear()
        
        showMessage(
          response?.message,
           "success"
        );
        navigate("/login");
      }
    } catch (error: any) {
      console.error("Failed to logout", error);
        if (error.message === 'GlobalHandledError') return;
         showMessage(
        error?.response?.data.message || "Logout Failed",
        "error"
      );
    }finally{
      setLoading(false);
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: backgroundColor,
        boxShadow: 0,
        zIndex: 1001,
        maxHeight: "58px"
      }}
    >
      <Toolbar>
        {/* Left side: Brand */}
        <Box
          sx={{ display: "flex", flexGrow: 1, alignItems: "center", ml: collapse ? 24 : 28 }}
        >
          <Typography
            sx={{ color: "white", fontSize: "15px", fontWeight: 400 }}
          >
            {/* Willsoar Technologies */}
            Hi, {getLocalValue(LoacalVariables.Name)}
          </Typography>
        </Box>

        {/* Right side: Nav Items */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Feedback Button */}
          <Button
            sx={{
              color: "#fff",
              fontWeight: 500,
              fontSize: "14px",
              textTransform: "none",
              padding: "4px 8px",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.1)"
              }
            }}
            onClick={openFeedbackMenu}
          >
            {/* Feedback Icon */}
            <SvgIcon sx={{ color: "#fff", fontSize: 20, mr: 1 }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
              >
                <g clipPath="url(#clip0_3904_30190)">
                  <path
                    d="M19.25 12.9999V16.7499C19.25 17.3466 19.0129 17.9189 18.591 18.3408C18.169 18.7628 17.5967 18.9999 17 18.9999H13.25C12.1978 18.9988 11.1644 18.721 10.2535 18.1945C9.34255 17.6679 8.58609 16.9111 8.06 15.9999C8.6254 15.9958 9.18888 15.9335 9.7415 15.8139C10.1624 16.3401 10.6962 16.7649 11.3036 17.0567C11.9109 17.3486 12.5762 17.5 13.25 17.4999H17C17.1989 17.4999 17.3897 17.4208 17.5303 17.2802C17.671 17.1395 17.75 16.9488 17.75 16.7499V12.9999C17.7498 12.3258 17.5979 11.6604 17.3055 11.053C17.0131 10.4457 16.5878 9.91192 16.061 9.49136C16.1816 8.93884 16.245 8.37536 16.25 7.80986C17.1612 8.33594 17.9181 9.0924 18.4446 10.0033C18.9712 10.9143 19.2489 11.9477 19.25 12.9999ZM14.7327 8.23811C14.8029 7.27184 14.6642 6.30179 14.3261 5.39388C13.9881 4.48597 13.4585 3.66147 12.7734 2.97642C12.0884 2.29137 11.2639 1.76181 10.356 1.42372C9.44807 1.08564 8.47802 0.946961 7.51175 1.01711C5.79944 1.21265 4.21769 2.02749 3.06438 3.30816C1.91107 4.58884 1.26577 6.24698 1.25 7.97036L1.25 11.7504C1.25 13.6494 2.38025 14.4999 3.5 14.4999H7.775C9.4991 14.485 11.1583 13.8402 12.4398 12.6868C13.7214 11.5334 14.5369 9.95112 14.7327 8.23811ZM11.7125 4.03811C12.245 4.57173 12.6566 5.21351 12.9195 5.92C13.1824 6.62649 13.2905 7.38121 13.2365 8.13311C13.0764 9.47086 12.4329 10.704 11.427 11.6003C10.4211 12.4967 9.12229 12.9944 7.775 12.9999H3.5C2.804 12.9999 2.75 12.0436 2.75 11.7504V7.97036C2.75625 6.62364 3.25449 5.32563 4.15094 4.32061C5.04739 3.31559 6.28025 2.67286 7.6175 2.51336C7.742 2.50436 7.8665 2.49986 7.991 2.49986C8.68195 2.49921 9.36626 2.63473 10.0048 2.89867C10.6434 3.16261 11.2236 3.5498 11.7125 4.03811Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3904_30190">
                    <rect
                      width="18"
                      height="18"
                      fill="white"
                      transform="translate(1.25 1)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </SvgIcon>
            Feedback ▾
          </Button>

          {/* Feedback Dropdown */}
          <Menu
            anchorEl={feedbackAnchor}
            open={Boolean(feedbackAnchor)}
            onClose={closeFeedbackMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                mt: 1,
                borderRadius: 2,
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                minWidth: 200,
                p: 1,
                "& .MuiMenuItem-root": {
                  fontSize: "13px",
                  py: 1,
                  px: 2,
                  borderRadius: 1,
                  color: "#0b1a36",
                  "&:hover": {
                    backgroundColor: "#e6f0fa"
                  }
                }
              }
            }}
          >
            <MenuItem onClick={closeFeedbackMenu}>Ask a Question</MenuItem>
            <MenuItem onClick={closeFeedbackMenu}>Suggest Features</MenuItem>
            <MenuItem onClick={closeFeedbackMenu}>Share Feedback</MenuItem>
            <MenuItem onClick={closeFeedbackMenu}>Report a Bug</MenuItem>
            <MenuItem onClick={closeFeedbackMenu}>Product Roadmap</MenuItem>
            <MenuItem onClick={closeFeedbackMenu}>Release Notes</MenuItem>
          </Menu>

          {/* Invite Team Button */}
          <Button
            variant="contained"
            color="warning"
            sx={{
              textTransform: "none",
              backgroundColor: "#fe6a2c",
              ml: 2,
              fontSize: "12px",
              fontWeight: 500,
              border: 0
            }}
          >
            Invite Your Team
          </Button>

          {/* Profile Button */}
          <IconButton onClick={openProfileMenu}>
            <Avatar />
          </IconButton>

          {/* Custom Dropdown Menu */}
          <Menu
            anchorEl={profileAnchor}
            open={Boolean(profileAnchor)}
            onClose={closeProfileMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                width: 180,
                borderRadius: 2,
                boxShadow: 3
              }
            }}
          >
            <MenuItem
              sx={{
                color: "#0b1a36",
                "&:hover": {
                  backgroundColor: "#e6f0fa" // or any custom hover color
                }
              }}
            >
              <Typography variant="body2">WillSoar Technologies</Typography>
            </MenuItem>

            <Divider />

            <MenuItem
              component={Link}
              to="/users"
              sx={{
                color: "#0b1a36",
                "&:hover": {
                  backgroundColor: "#e6f0fa"
                }
              }}
            >
              <ListItemIcon>
                <WSIcons.Users fontSize="small" />
              </ListItemIcon>
              <Typography variant="body2">Users</Typography>
            </MenuItem>

            <MenuItem
              component={Link}
              to="/billing"
              sx={{
                color: "#0b1a36",
                "&:hover": {
                  backgroundColor: "#e6f0fa"
                }
              }}
            >
              <ListItemIcon>
                <WSIcons.Billing fontSize="small" />
              </ListItemIcon>
              <Typography variant="body2">Billing</Typography>
            </MenuItem>

            <MenuItem
              component={Link}
              to="/users"
              sx={{
                color: "#0b1a36",
                "&:hover": {
                  backgroundColor: "#e6f0fa"
                }
              }}
            >
              <ListItemIcon>
                <WSIcons.SettingsIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="body2">Settings</Typography>
            </MenuItem>

            <MenuItem
              component={Link}
              to={`/myAccount/${UserId}`}
              sx={{
                color: "#0b1a36",
                "&:hover": {
                  backgroundColor: "#e6f0fa"
                }
              }}
            >
              <ListItemIcon>
                <WSIcons.AccountCircleIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="body2">My Account</Typography>
            </MenuItem>

            <MenuItem
              onClick={handleLogout}
              sx={{
                color: "#0b1a36",
                "&:hover": { backgroundColor: "#e6f0fa" }
              }}
            >
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              <Typography variant="body2">Logout</Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>

      <WSLoadingOverlay loading={loading}/>
    </AppBar>
  );
};

export default Navbar2;
